import { render } from "./ProjectTemplatesComp.vue?vue&type=template&id=0fe0267e&scoped=true"
import script from "./ProjectTemplatesComp.vue?vue&type=script&lang=js"
export * from "./ProjectTemplatesComp.vue?vue&type=script&lang=js"

import "./ProjectTemplatesComp.vue?vue&type=style&index=0&id=0fe0267e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe0267e"]])

export default __exports__